import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Plus } from "react-feather"
import { useTranslation } from "react-i18next"
import { getDefaultCountry } from "../../../Crear/redux/selectors/newDocumentoSettingsSelectors"
import {
  addEmptyDireccion,
  empresaSelector,
} from "../../redux/slices/empresaSlice"
import FormDirecciones from "./FormDirecciones/index"

const Direcciones = () => {
  const { t } = useTranslation()
  const { direcciones } = useSelector(empresaSelector)
  const {
    activeCompany: { id },
  } = useUsuarioEmpresaActiva()
  const businessDefaultCountry = useSelector(getDefaultCountry)

  const dispatch = useDispatch()

  const handleAddEmptyDireccion = () => dispatch(addEmptyDireccion())

  return (
    <div className='w-full px-2 py-2'>
      {direcciones?.map(
        (direccion: $TSMigrationFixMe, i: $TSMigrationFixMe) => (
          <div
            key={direccion.id}
            className={`w-full mb-4 ${i !== 0 ? "mt-4 border-t-1" : ""}`}
          >
            <FormDirecciones
              // @ts-expect-error TS(2322): Type '{ data: $TSFixMe; empresaId: string | undefined; ...
              data={direccion}
              empresaId={id}
              businessDefaultCountry={businessDefaultCountry}
              t={t}
            />
          </div>
        )
      )}

      <div className='justify-start w-full d-flex'>
        <span className='items-center justify-center underline text-gedesco pointer d-flex'>
          <Plus
            width={20}
            strokeWidth={3}
          />
          <span
            onClick={handleAddEmptyDireccion}
            className='ml-1 translate-y-1'
          >
            {t("perfilEmpresa.directions.addDirection")}
          </span>
        </span>
      </div>
    </div>
  )
}

export default Direcciones
